import { Injectable } from '@angular/core';
import { ContentfulService } from 'src/app/shared/services/contentful.service';
import { Entry } from 'contentful';
import { ContentFulModel } from 'src/app/shared/models/contentfulmodel';
import { BehaviorSubject } from 'rxjs';
import { PageId } from 'src/app/shared/utilities/pageids.enum';
import { MetaService } from 'src/app/shared/services/meta.service';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class WebinarpageService {
  getUrl: any;
  constructor(
    private contentful: ContentfulService,
    private meta: MetaService,
    private route: Router
  ) {
    this.getUrl = this.route.url;
  }

  webinarData: any;
  webinarArticleData: any;

  private getStartedSubject$ = new BehaviorSubject<any>(null);
  public getStarted$ = this.getStartedSubject$.asObservable();
  private webinarDataSubject$ = new BehaviorSubject<any>(null);
  public webinarData$ = this.webinarDataSubject$.asObservable();
  private webinarArticleDataSubject$ = new BehaviorSubject<any>(null);
  public webinarArticleData$ = this.webinarArticleDataSubject$.asObservable();

  getWebinarData() {
    this.contentful
      .getEntries(
        Object.assign({
          content_type: PageId.webinarsPodcasts,
          include: 10,
        })
      )
      .then(res => {
        let mod = res.items as Entry<any>[];
        this.webinarData = mod[0].fields;
        let metaBody = {
          title: '',
          description: '',
          url: '',
          image: '',
          type: '',
        };
        const getStarted = this.webinarData.gettingStartedPanel.fields;
        if (getStarted) {
          this.getStartedSubject$.next(getStarted);
        }
        const webinarData = this.webinarData;
        if (webinarData) {
          this.webinarDataSubject$.next(webinarData);
        }

        metaBody.title = this.webinarData?.seoMetaDataReference?.fields?.title || 'Verto: Cross-border payments platform for businesses';
        metaBody.description = this.webinarData?.seoMetaDataReference?.fields?.description || 'Verto: Cross-border payments platform for businesses across the globe.';
        metaBody.type = 'Webinars And Podcasts';
        metaBody.url = this.getUrl;
        metaBody.image = this.webinarData?.whitepapersAndReportsImage?.fields?.file?.url;
        this.meta.updateOG(metaBody);
        const seoData = this.webinarData?.seoMetaDataReference?.fields;
        if (seoData) {
          this.meta.updateMeta(seoData);
        }
      });
  }
  getAllWebinarArticles(): Promise<Entry<any>[]> {
    return this.contentful
      .getEntries(
        Object.assign({
          access_token: PageId.accessToken,
          content_type: PageId.webinarsPodcastsArticles,
          include: 10,
          limit: 300
        })
      )
      .then(res => res.items);
  }
  getwebinarArticleByID(query: any): Promise<Entry<any>[]> {
    return this.contentful
      .getEntries(
        Object.assign({
          access_token: PageId.accessToken,
          include: 10,
          content_type: PageId.webinarsPodcastsArticles,
          'fields.blogId': query,
        })
      )
      .then(res => res.items);
  }

  getwebinarArticleData(id: string) {
    this.getwebinarArticleByID(id).then(data => {
      this.webinarArticleData = data[0].fields;
      if (this.webinarArticleData) {
        this.webinarArticleDataSubject$.next(this.webinarArticleData);
      }
    });
  }
}
